import { ReactComponent as LocationMarker } from "../../../assets/images/icons/location-mark.svg";

const OurSuppliers = ({ suppliers }) => (
  <div className="flex flex-col justify-center items-center -mt-20 pb-32">
    <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-blue-850 mb-20">
      Our Suppliers
    </h2>

    {suppliers?.map((supplier) => (
      <div
        key={supplier._id}
        className="cont grid md:grid-cols-3 w-5/6 md:w-3/4 -mt-10 md:mt-0 mb-20 md:mb-40"
      >
        <div className="md:col-span-2 bg-blue-650 bg-opacity-20 p-3 md:p-6">
          <h4 className="text-xl md:text-2xl lg:text-3xl">{supplier.name}</h4>
          <div className="flex items-center">
            <LocationMarker className="-ml-3 lg:ml-0 p-3 fill-blue-950" />
            <h6 className="text-blue-850 md:text-lg lg:text-xl">
              {supplier.country}{" "}
            </h6>
            <img
              className="ml-3 w-7"
              src={supplier.countryImage}
              alt={supplier.country}
            />
          </div>
          <p className="text-sm lg:text-base">{supplier.description}</p>
        </div>

        <div className="bg-blue-850 flex justify-center items-center h-32 md:h-auto">
          <img
            src={supplier.image}
            alt={supplier.name}
            className="w-40 h-20 lg:w-48 lg:h-24 xl:w-60 xl:h-32"
          />
        </div>
      </div>
    ))}
  </div>
);

export default OurSuppliers;
